<footer class="footer">
  <div class="footer-content">
    <div class="footer-brand">
      <div class="logo-container logo--large">
        <app-icon [icon]="IconName.LOGOWHITE" style="--icon-width: 44px; --icon-height: 44px" />
        <span class="secondary-text logotext">RetailTech</span>
      </div>
      <p class="default-text footer-description">
        {{ footerDescription.descriptionKey | translate }}
      </p>
    </div>

    <div class="footer-sections">
      @for (section of footerSections; track section) {
        <div class="footer-section">
          <h3 class="heading-sm section-title">
            {{ section.titleKey | translate }}
          </h3>
          <ul class="section-links">
            @for (link of section.links; track link) {
              <li>
                <a [href]="link.url" class="footer-link default-text">
                  {{ link.labelKey | translate }}
                </a>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>

  <div class="footer-bottom">
    <div class="copyright tag">{{ currentYear }} {{ copyright.copyrightKey | translate }}</div>

    <div class="social-links">
      @for (social of socialLinks; track social) {
        <a [href]="social.url" target="_blank" class="social-link">
          <app-icon [icon]="social.icon" class="social-icon" />
        </a>
      }
    </div>
  </div>
</footer>
